<template>
  <div class="the-navbar__user-meta flex items-center" >

    <div v-if="profile">

      <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">

        <div class="con-img md:mx-6 flex items-center">
          <svg v-if="myProfile.photo === null" viewBox="0 0 212 212" width="40" height="40" class="mr-2"><path fill="#DFE5E7" class="background" d="M106.251.5C164.653.5 212 47.846 212 106.25S164.653 212 106.25 212C47.846 212 .5 164.654.5 106.25S47.846.5 106.251.5z"></path><g fill="#FFF"><path class="primary" d="M173.561 171.615a62.767 62.767 0 0 0-2.065-2.955 67.7 67.7 0 0 0-2.608-3.299 70.112 70.112 0 0 0-3.184-3.527 71.097 71.097 0 0 0-5.924-5.47 72.458 72.458 0 0 0-10.204-7.026 75.2 75.2 0 0 0-5.98-3.055c-.062-.028-.118-.059-.18-.087-9.792-4.44-22.106-7.529-37.416-7.529s-27.624 3.089-37.416 7.529c-.338.153-.653.318-.985.474a75.37 75.37 0 0 0-6.229 3.298 72.589 72.589 0 0 0-9.15 6.395 71.243 71.243 0 0 0-5.924 5.47 70.064 70.064 0 0 0-3.184 3.527 67.142 67.142 0 0 0-2.609 3.299 63.292 63.292 0 0 0-2.065 2.955 56.33 56.33 0 0 0-1.447 2.324c-.033.056-.073.119-.104.174a47.92 47.92 0 0 0-1.07 1.926c-.559 1.068-.818 1.678-.818 1.678v.398c18.285 17.927 43.322 28.985 70.945 28.985 27.678 0 52.761-11.103 71.055-29.095v-.289s-.619-1.45-1.992-3.778a58.346 58.346 0 0 0-1.446-2.322zM106.002 125.5c2.645 0 5.212-.253 7.68-.737a38.272 38.272 0 0 0 3.624-.896 37.124 37.124 0 0 0 5.12-1.958 36.307 36.307 0 0 0 6.15-3.67 35.923 35.923 0 0 0 9.489-10.48 36.558 36.558 0 0 0 2.422-4.84 37.051 37.051 0 0 0 1.716-5.25c.299-1.208.542-2.443.725-3.701.275-1.887.417-3.827.417-5.811s-.142-3.925-.417-5.811a38.734 38.734 0 0 0-1.215-5.494 36.68 36.68 0 0 0-3.648-8.298 35.923 35.923 0 0 0-9.489-10.48 36.347 36.347 0 0 0-6.15-3.67 37.124 37.124 0 0 0-5.12-1.958 37.67 37.67 0 0 0-3.624-.896 39.875 39.875 0 0 0-7.68-.737c-21.162 0-37.345 16.183-37.345 37.345 0 21.159 16.183 37.342 37.345 37.342z"></path></g></svg>
          <img v-else key="onlineImg" :src="myProfile.photo" alt="user-img" width="40" height="40" class="rounded-full shadow-md cursor-pointer block mr-2" />
          <small class="hidden md:block text-white">{{ truncateString(myProfile.name, 10) }}</small>
        </div>

        <vs-dropdown-menu class="vx-navbar-dropdown">
          <ul style="min-width: 9rem">

            <li
              class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
              @click="$router.push('/profile').catch(() => {})">
              <feather-icon icon="UserIcon" svgClasses="w-4 h-4" />
              <span class="ml-2">Profile</span>
            </li>

            <vs-divider class="m-1" />

            <li
              class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
              @click="logout">
              <feather-icon icon="LogOutIcon" svgClasses="w-4 h-4" />
              <span class="ml-2">Logout</span>
            </li>
          </ul>
        </vs-dropdown-menu>
      </vs-dropdown>      
    </div>
    <div class="mx-4" v-else>
      <router-link to="/login" class="flex items-center">
        <img src="/assets/images/user.svg" alt="" class="w-8 mr-2" />
        <span class="text-white">Login</span>
      </router-link>
    </div>
      
  </div>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/auth'
import {mapState} from 'vuex'

export default {
  data () {
    return {
      myProfile: {}
    }
  },
  computed: {
    ...mapState('auth', ['profile']),
    activeUserInfo () {
      return this.$store.state.AppActiveUser
    },
    token () {
      return localStorage.token
    }
  },
  methods: {
    logout () {
      this.$store.dispatch('auth/logout')
        .then(() => window.location.reload())
    }
  },
  created () {
    Object.assign(this.myProfile, this.profile)
    if(this.myProfile.file !== null) {
      this.myProfile.photo = process.env.VUE_APP_STORAGE + '/' + this.myProfile.file
    }
    else {
      this.myProfile.photo = null
      this.myProfile.file = null
    }
  }
}
</script>
